/* eslint-disable max-len */
export const WorkleapLmsIcon = () => {
    return (
        <svg width="16" height="16" viewBox="-5 -5 58 58" fill="currentColor">
            <path
                fill="currentColor"
                d="M24 4L0 16.0005L17.5641 24.783V21.5504C17.5641 21.0815 17.8036 20.6451 18.1992 20.3934L28.0988 14.0936C28.7378 13.687 29.5854 13.8754 29.9921 14.5144C30.3987 15.1534 30.2103 16.001 29.5713 16.4077L20.3069 22.3032V26.1545L24 28.0011L48 16.0005L24 4Z"
            />
            <path
                fill="currentColor"
                d="M21.33 18.4011H9.86703C9.10961 18.4011 8.49561 19.0151 8.49561 19.7726V20.2496L17.5632 24.7836V21.551C17.5632 21.0821 17.8028 20.6457 18.1984 20.394L21.33 18.4011Z"
            />
            <path
                fill="currentColor"
                d="M17.5632 27.8502V32.0505C17.5632 32.808 18.1772 33.422 18.9347 33.422C19.6921 33.422 20.3061 32.808 20.3061 32.0505V29.2217L22.7725 30.455C23.5447 30.8411 24.4536 30.8411 25.2259 30.455L39.4372 23.349V37.769C39.4372 38.2243 39.2112 38.65 38.834 38.9051C33.6712 42.3963 28.6296 44.014 23.6289 43.9174C18.6377 43.821 13.827 42.0195 9.11266 38.9143C8.72746 38.6606 8.49561 38.2302 8.49561 37.769V23.3162L17.5632 27.8502Z"
            />
            <path
                fill="currentColor"
                d="M20.3061 26.1551V22.3038L26.4389 18.4011H38.0658C38.8232 18.4011 39.4372 19.0151 39.4372 19.7726V20.2824L23.9992 28.0017L20.3061 26.1551Z"
            />
        </svg>
    );
};
